import * as $ from "jquery";

export interface ILogger {
    debug(...args: any[]) : void;
}

class Logger implements ILogger {
    constructor() {
    }

    public debug(...args: any[]): void {
        // uncomment code below to get in page logger view
        /*
        let $con = $('.debug-console');
        if ($con.length === 0) {
            $con = $('<div class="debug-console"></div>').appendTo($('body'));
        }
        $con.append($('<p></p>').text(args.toString()));
        */
        // console.log might not work, guard against failure
        try {
            console.log.apply(console, args);
        } catch (ignored) {
        }
    }
}

let _logger = new Logger();

export default _logger;


// WEBPACK FOOTER //
// ./../Intercom.ReactUI/Utils/logger.ts